import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/Layout/layout';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
          <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;